module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rfp-control"
  }, [_c('button', {
    staticClass: "rfp-trigger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.openModal
    }
  }, [_c('svg', {
    staticClass: "rfp-trigger-icon",
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.8",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M4 6h16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M4 12h10"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M4 18h7"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M18 14v6"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M15 17h6"
    }
  })]), _vm._v("\n    Fields\n    "), _c('span', {
    staticClass: "rfp-count"
  }, [_vm._v(_vm._s(_vm.visibleCount) + "/" + _vm._s(_vm.totalCount))])]), _vm._v(" "), _c('modal', {
    staticClass: "rfp-modal",
    attrs: {
      "name": _vm.modalName,
      "adaptive": true,
      "scrollable": true,
      "height": "auto",
      "width": "90%",
      "maxWidth": 620
    },
    on: {
      "before-open": _vm.prepareDraft
    }
  }, [_c('div', {
    staticClass: "rfp-dialog"
  }, [_c('div', {
    staticClass: "rfp-dialog-header"
  }, [_c('div', {
    staticClass: "rfp-dialog-header-left"
  }, [_c('span', {
    staticClass: "rfp-dialog-icon"
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.8",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M4 6h16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M4 12h16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M4 18h16"
    }
  })])]), _vm._v(" "), _c('div', [_c('h2', {
    staticClass: "rfp-dialog-title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('p', {
    staticClass: "rfp-dialog-sub"
  }, [_vm._v(_vm._s(_vm.subtitle))])])]), _vm._v(" "), _c('button', {
    staticClass: "rfp-close-btn",
    attrs: {
      "type": "button",
      "title": "Close"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('line', {
    attrs: {
      "x1": "18",
      "y1": "6",
      "x2": "6",
      "y2": "18"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "6",
      "y1": "6",
      "x2": "18",
      "y2": "18"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "rfp-dialog-body"
  }, [_c('div', {
    staticClass: "rfp-summary"
  }, [_c('span', {
    staticClass: "rfp-summary-label"
  }, [_vm._v(_vm._s(_vm.draftVisibleCount) + " selected")]), _vm._v(" "), _c('span', {
    staticClass: "rfp-summary-text"
  }, [_vm._v("Locked fields stay visible for navigation and actions.")])]), _vm._v(" "), _vm._l((_vm.groupedFields), function(group) {
    return _c('div', {
      key: group.name,
      staticClass: "rfp-group"
    }, [_c('h3', {
      staticClass: "rfp-group-title"
    }, [_vm._v(_vm._s(group.name))]), _vm._v(" "), _c('div', {
      staticClass: "rfp-field-grid"
    }, _vm._l((group.fields), function(field) {
      return _c('label', {
        key: field.id,
        staticClass: "rfp-option",
        class: {
          'rfp-option--locked': field.locked
        }
      }, [_c('input', {
        staticClass: "rfp-checkbox",
        attrs: {
          "type": "checkbox",
          "disabled": field.locked
        },
        domProps: {
          "checked": _vm.isDraftSelected(field.id)
        },
        on: {
          "change": function($event) {
            return _vm.toggleDraft(field.id)
          }
        }
      }), _vm._v(" "), _c('span', {
        staticClass: "rfp-checkmark"
      }, [(_vm.isDraftSelected(field.id)) ? _c('svg', {
        attrs: {
          "viewBox": "0 0 24 24",
          "fill": "none",
          "stroke": "currentColor",
          "stroke-width": "2.2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      }, [_c('path', {
        attrs: {
          "d": "M20 6L9 17l-5-5"
        }
      })]) : _vm._e()]), _vm._v(" "), _c('span', {
        staticClass: "rfp-option-text"
      }, [_c('span', {
        staticClass: "rfp-option-label"
      }, [_vm._v(_vm._s(field.label))]), _vm._v(" "), (field.locked) ? _c('span', {
        staticClass: "rfp-locked"
      }, [_vm._v("Locked")]) : _vm._e()])])
    }), 0)])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "rfp-dialog-footer"
  }, [_c('button', {
    staticClass: "rfp-reset-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.resetDefaults
    }
  }, [_vm._v("Reset defaults")]), _vm._v(" "), _c('button', {
    staticClass: "rfp-cancel-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "rfp-save-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.applySelection
    }
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "17 21 17 13 7 13 7 21"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "7 3 7 8 15 8"
    }
  })]), _vm._v("\n          Apply\n        ")])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1d9b02ea"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LiveRun/Race/RunnerFieldVisibilityControl.vue
// module id = 1676
// module chunks = 2